<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="nodesModal" tabindex="-1" role="dialog" aria-labelledby="nodesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">{{ rack.name }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="!loading" class="modal-body">
            <label class="typo__label">Nodes</label>
            <multiselect v-model="value" :options="allNodes" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select nodes" label="nodeFname" track-by="nodeFname" :preselect-first="false">
            </multiselect>
            <div class="col-md-12 text-right">
              <button @click="submit" :disabled="loading" type="button" class="btn btn-primary">Submit</button>
            </div>
            <div v-if="rack.nodes && rack.nodes.length>0" class="row">
              <div class="col-md-8">
                <h5>Assigned Nodes</h5>
              </div>

            </div>
            <div v-for="(row, index) in rack.nodes" :key="index" class="row border-bottom mt-3">
              <div class="col-md-10">
                <span>{{ row.nodeFname }}</span>
              </div>

              <div class="col-md-2">
                <span @click="unassignNode(row)" class="details-control shown "></span>

              </div>
              <hr>
            </div>

          </div>
          <div v-else class="loader"></div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "NodesModal",
  components: {
    Multiselect
  },
  data() {
    return {
      loading: false,
      value: [],
      allNodes: [],
      rack: {}
    }
  },
  methods: {
    async load(rack) {
      this.value=[]
      this.rack=rack
      console.log(this.rack)
      await this.getAllNodes()
      $('#nodesModal').modal('show');
    },
    async getAllNodes(){
      this.allNodes=[];
      this.loading=true
      const nodesResp= await db.collection('nodes').get();
       nodesResp.forEach(el => {
        this.allNodes.push({id: el.id, ...el.data(),  $isDisabled: el.data().rackId});
      })
      this.allNodes = this.allNodes.filter(el => !el.deleted)
      console.log(this.allNodes)
      this.loading=false;

    },
    unassignNode(row){
      try{
        swal({
          title: "Un-assign Node",
          text: "Are you sure to un-assign this node?",
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then(async result =>  {
          if(result.value){
            row.rackId=null;
            row.rack_name=null
            this.loading=true
            await db.collection('nodes').doc(row.id).update(row)

            await this.$parent.$refs.allRacks.getAllRacks();
            this.loading=false
            swal({
              title: "Success",
              text: "You have successfully un-assigned node  " ,
              type: "success",
            });
            $('#nodesModal').modal('hide');
          }
        }).catch((err)=>{
          this.loading=false
          swal({
            title: "Error",
            text: "Error while un-assigning nodes " ,
            type: "error",
          });
          $('#nodesModal').modal('hide');
        });
      }
      catch(err){
        this.loading=false
        swal({
          title: "Error",
          text: "Error while un-assigning nodes " ,
          type: "error",
        });
        $('#nodesModal').modal('hide');
      }
    },
    async submit(){
      try{
        console.log('selected nodes', this.value)
        console.log('selected rack', this.rack)
        this.loading=true;
        for (let node of this.value) {
          await db.collection('nodes').doc(node.id).update({
            rackId: this.rack.id,
            rack_name: this.rack.name
          })
        }
        await this.$parent.$refs.allRacks.getAllRacks();
        swal({
          title: "Success",
          text: "You have successfully assigned nodes to " + this.rack.name,
          type: "success",
        });
      }
      catch(e){
        console.log(e.toString())
        swal({
          title: "Error",
          text: "Something went wrong while assiging nodes",
          type: "error",
        });
      }finally {
        this.loading=false
        this.value=[]
        $('#nodesModal').modal('hide');

      }



    }

  }
}
</script>

<style scoped>

</style>
